export default "__VITE_ASSET__BT9rr$e___"